<template>
    <div :class="'bizcomp-acct-security bizcomp ' + className">
        <div>
            <div class="acct-security-head-contain">
                <img src="../../assets/img/account-security.png" alt="" />
                <div>您的账户安全等级</div>
                <div class="acct-security-level-text">
                    {{ securityLevelC[securityLevel] }}
                </div>
                <img src="../../assets/img/security-level.png" alt="" />
                <img
                    src="../../assets/img/inverted-triangle.png"
                    alt=""
                    :class="
                        'point-triangle-img1 ' +
                        (securityLevel == 2
                            ? 'point-triangle-img2 '
                            : securityLevel == 3
                            ? 'point-triangle-img3'
                            : '')
                    "
                />
            </div>
            <div class="acct-security-content">
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="isbind" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">密码</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div></div>
                            <div>
                                <span class="color-e60012 cursor-pointer" v-on:click="changeLPwd">
                                    修改登录密码
                                </span>
                                <span class="margin-5">/</span>
                                <span class="color-e60012 cursor-pointer" v-on:click="changeTPwd">
                                    修改交易密码
                                </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="info.mobileno" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">手机号码</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>{{ $util.desensitizePhoneNumber(info.mobileno) }}</div>
                            <div class="color-e60012 cursor-pointer" v-on:click="modifyMobile">
                                修改
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="info.email" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">电子邮箱</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>{{ info.email }}</div>
                            <div class="color-e60012 cursor-pointer" v-on:click="modifyEmail">
                                修改
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <!-- <el-row class="el-row-common">
                    <el-col class="flex-align-center" :span="8">
                        <img src="../../assets/img/no-finish-icon.png" alt="" />
                        <span class="padding-left-14"> 交易通知和短信</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>
                                系统免费帮您开通短信通知服务，资金变动第一时间通知
                            </div>
                            <div class="color-e60012">更换手机号码</div>
                        </div>
                    </el-col>
                </el-row> -->
            </div>
        </div>
        <check-mobile
            :show-mobile-comp="showMobileComp"
            v-on:dialog-close="dialogCloseFn"
        ></check-mobile>
        <change-emial
            :show-email-comp="showEmailComp"
            v-on:dialog-close="dialogCloseFn"
        ></change-emial>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import checkMobile from "./checkMobileDc.vue";
import changeEmial from "./changeEmialDc.vue";
export default {
    name: "AcctSecurityDc",
    components: {
        checkMobile,
        changeEmial
    },
    mixins: [mixin],
    data() {
        return {
            showMobileComp: false,
            showEmailComp: false,
            securityLevel: 0,
            securityLevelC: ["低", "低", "中", "高"],
            isbind: false,
            info: {}
        };
    },

    created() {
        this.info = this.$cache.getUser();
        this.isbind = sessionStorage.getItem("binded");
        if (this.isbind) {
            this.securityLevel += 1;
        }
        if (this.info.mobileno) {
            this.securityLevel += 1;
        }
        if (this.info.email) {
            this.securityLevel += 1;
        }
    },
    methods: {
        changeLPwd() {
            this.$router.push({ name: "changelpwd" });
        },
        changeTPwd() {
            this.$router.push({ name: "changetpwd" });
        },
        modifyMobile() {
            this.showMobileComp = true;
        },
        modifyEmail() {
            this.showEmailComp = true;
        },
        dialogCloseFn(value) {
            this.showMobileComp = value;
            this.showEmailComp = value;
            this.info = this.$cache.getUser();
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-acct-security {
    position: relative;
    .acct-security-head-contain {
        display: flex;
        align-items: center;
        height: 110px;
        border-radius: 6px;
        background: linear-gradient(180deg, #ffefe5 0%, #ffe6d5 100%);
        font-weight: normal;
        font-size: 16px;
        .acct-security-level-text {
            margin: 0 16px;
            font-size: 20px;
            font-weight: 500;
        }
        .point-triangle-img1 {
            position: absolute;
            left: 315px;
            top: 35px;
        }
        .point-triangle-img2 {
            position: absolute;
            left: 405px;
            top: 35px;
        }
        .point-triangle-img3 {
            position: absolute;
            left: 495px;
            top: 35px;
        }
    }
    .acct-security-content {
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
        margin-top: 30px;
        .el-row-common {
            height: 50px;
            line-height: 50px;
            padding: 0 16px;
        }
    }
    .flex-space-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .flex-align-center {
        display: flex;
        align-items: center;
    }
    .color-e60012 {
        color: #e60012;
    }
    .padding-left-14 {
        padding-left: 14px;
    }
    .background-f9f9f9 {
        background-color: #f9f9f9;
    }
    .margin-5 {
        margin: 0 5px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
}
</style>
